import Typography from '@mui/material/Typography'

import { formatDate, isBefore, subtractWeeks } from '@util/date-util'
import { getWeeksBeforeStartUitvoering } from '@util/planningsconflict-util'

import { useTemplatesSearch } from '../../aansluiting/contractinstellingen/hooks/useTemplatesSearch'
import type { ActiviteitTemplate } from '../../templates/types/ActiviteitTemplate'
import { StyledAlert } from '../../theme/components/StyledAlert'

interface Props {
  geplandeUitvoeringsdatum: string
  geplandeUitvoeringsdatumType: string
  opleverdatum: any
  combi?: string
  templates?: ActiviteitTemplate[]
}

export default function PlanningConflict({
  geplandeUitvoeringsdatum,
  geplandeUitvoeringsdatumType,
  opleverdatum,
  combi,
  templates: providedTemplates,
}: Props) {
  const { data } = useTemplatesSearch({
    externalFilters: { combi: combi || null },
  })
  const templates = providedTemplates || data.activiteitTemplates

  const amountOfWeeks = getWeeksBeforeStartUitvoering(combi, templates)
  const uitvoering = new Date(geplandeUitvoeringsdatum)
  const oplever = new Date(opleverdatum)
  const show =
    isBefore(subtractWeeks(uitvoering, amountOfWeeks) as any, oplever) &&
    geplandeUitvoeringsdatumType === 'Planning door uitvoerende aannemer'

  return (
    <>
      {show && (
        <StyledAlert
          severity="warning"
          title="Deze keuzes van data leiden tot een planning conflict"
        >
          <Typography>
            {`De werkvoorbereiding moet ${amountOfWeeks} weken (${formatDate(
              subtractWeeks(uitvoering, amountOfWeeks),
            )}) voor de geplande start uitvoering (${formatDate(
              geplandeUitvoeringsdatum,
            )}) afgerond zijn.`}
          </Typography>
        </StyledAlert>
      )}
    </>
  )
}
